import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSocketIO from 'vue-socket.io'
//import Home from '../views/Home.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/Main.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/control',
    name: 'Control',
    component: () => import('../views/Control.vue'),
    beforeEnter (to, from, next) {
       if (!Vue.prototype.$socket) { 
         Vue.use(new VueSocketIO({
            debug: true,
            /* connection: 'http://103.211.218.36:322' */
             connection: 'https://esmart.ccms.live:8016'
            //connection: 'http://103.211.219.21:33346'  
            
          })
        );
       }
       next()
    }
  },
  {
    path: '/livedata/:ulbareacode',
    name: 'Devices',
    component: () => import('../views/Livedata.vue'),
    beforeEnter (to, from, next) {
       if (!Vue.prototype.$socket) { 
        // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
         Vue.use(new VueSocketIO({
            debug: false,
            connection:'https://esmart.ccms.live:8016'
          })
        );
       }
       next()
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/complaints',
    name: 'Complaints',
    component: () => import('../views/Complaints.vue')
  },
  {
    path: '/state-dashboard/:stateid',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/user-roles',
    name: 'User Roles',
    component: () => import('../views/UserRoles.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue')
  },
  {
    path: '/devices/:ulbareacode',
    name: 'Devices',
    component: () => import('../views/Devices.vue'),
    beforeEnter (to, from, next) {
      if (!Vue.prototype.$socket) { 
       // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
        Vue.use(new VueSocketIO({
            debug: true,
            connection: 'https://esmart.ccms.live:8016'
          })
        );
      }
      next()
    }
  },
  {
    path: '/device-data/:imeino',
    name: 'Device Record',
    component: () => import('../views/DeviceRecord.vue'),
    beforeEnter (to, from, next) {
      if (!Vue.prototype.$socket) { 
       // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
        Vue.use(new VueSocketIO({
            debug: true,
            connection: 'https://esmart.ccms.live:8016'
          })
        );
      }
      next()
    }
  },
  {
    path: '/device-fault/:imeino',
    name: 'Device Fault Record',
    component: () => import('../views/DeviceFaultLogs.vue')
  },
  {
    path: '/devices-filter/:filter',
    name: 'Devices Filter',
    component: () => import('../views/DevicesFiIter.vue')
  },
  {
    path: '/report-ulb/:ulbareacode',
    name: 'ULB Record',
    component: () => import('../views/UlbReport.vue')
  },
  {
    path: '/zones',
    name: 'Zone Record',
    component: () => import('../views/Zones.vue')
  },
  {
    path: '/device-group',
    name: 'Device group',
    component: () => import('../views/DeviceGroup.vue')
  },
  {
    path: '/schedule',
    name: 'Manage Schedule',
    component: () => import('../views/Schedule.vue')
  },  
  {
    path: '/ulbs',
    name: 'ULB Record',
    component: () => import('../views/ULBs.vue'),
    beforeEnter (to, from, next) {
      if (!Vue.prototype.$socket) { 
       // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
        Vue.use(new VueSocketIO({
            debug: true,
            connection: 'https://esmart.ccms.live:8016'
          })
        );
      }
      next()
    }
  },
  {
    path: '/wards',
    name: 'Ward Record',
    component: () => import('../views/Wards.vue')
  },
  {
    path: '/cities',
    name: 'City Record',
    component: () => import('../views/City.vue')
  },
  {
    path: '/controllers/:feederno',
    name: 'Controllers',
    component: () => import('../views/Controller.vue')
  },
  {
    path: '/controller-data/:uniqueid',
    name: 'Controller Data',
    component: () => import('../views/ControllerRecord.vue')
  },
  {
    path: '/device-report',
    name: 'Download Device Report',
    component: () => import('../views/DeviceReport.vue')
  },
  {
    path: '/device-report-page',
    name: 'Download Device Report',
    component: () => import('../views/DeviceReportpag.vue')
  },
  {
    path: '/reports/mcb-trip',
    name: 'Mcb Trip Report',
    component: () => import('../views/McvtripReport.vue')
  },
   {
    path: '/reports/mcb-trip-cumulative',
    name: 'Mcb Trip Cumulative Report',
    component: () => import('../views/McvtripCumulativeReport.vue')
  },
   {
    path: '/reports/power-outage',
    name: 'Power Outage Report',
    component: () => import('../views/PoweroutageReport.vue')
  },
  {
    path: '/reports/onoff-report',
    name: 'On/Off Report',
    component: () => import('../views/OnoffReport.vue')
  },
  {
    path: '/reports/hs-failure-report',
    name: 'SH/Off Report',
    component: () => import('../views/HsfailureReport.vue')
  },  
  {
    path: '/reports/glow-hr-report',
    name: 'Glow Hr Report',
    component: () => import('../views/GlowhrReport.vue')
  }, 
  {
    path: '/reports/non-glow-hr-report',
    name: 'Non Glow Hr Report',
    component: () => import('../views/NonglowhrReport.vue')
  },  
  {
    path: '/reports/uptime-report',
    name: 'Uptime Report',
    component: () => import('../views/UptimeReport.vue')
  }, 
  {
    path: '/reports/uptime-daily-cumulative-report',
    name: 'Uptime Daily Cum Report',
    component: () => import('../views/UptimecumulativeReport.vue')
  }, 
  {
    path: '/reports/uptime-monthly-report',
    name: 'Uptime Monthly Report',
    component: () => import('../views/UptimemonthlyReport.vue')
  },     
  {
    path: '/ulb-report',
    name: 'Download ULB Report',
    component: () => import('../views/ReportULB.vue')
  },
  {
    path: '/device-reports',
    name: 'Download Device Report',
    component: () => import('../views/DailyReports.vue')
  },
  {
    path: '/consumption',
    name: 'Consumption Record',
    component: () => import('../views/Consumption.vue')
  },
  {
    path: '/consumption2',
    name: 'Consumption Record',
    component: () => import('../views/Consumption2.vue')
  },
  {
    path: '/dashboard-reports',
    name: 'Dashboard Reports',
    component: () => import('../views/DashboardReports.vue')
  },
  {
    path: '/dashboard-report-details/:deviceId',
    name: 'Dashboard Reports device',
    component: () => import('../views/DeviceRecorddashboard.vue')
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance.vue')
  },
  {
    path: '/ccms-testing',
    name: 'CCMS Testing',
    component: () => import('../views/PortTester.vue')
  },
  {
    path: '/replace-devices',
    name: 'Replace Device',
    component: () => import('../views/ReplaceDevice.vue')
  },
  {
    path: '/monthlyconsumption',
    name: 'Consumption Record',
    component: () => import('../views/MonthlyConsumption.vue')
  },
  {
    path: '/reports/:reporttype',
    name: 'Download Reports',
    component: () => import('../views/Reports.vue')
  },
  {
    path: '/find-device',
    name: 'Search CCMS',
    component: () => import('../views/FindDevice.vue')
  },
  {
    path: '/live-tracking',
    name: 'Live Tracking',
    component: () => import('../views/LiveTracking.vue')
  },
  {
    path: '/corrections',
    name: 'Download Reports',
    component: () => import('../views/DeviceCorrection.vue')
  },
  {
    path: '/master-devices',
    name: 'Master Devices',
    component: () => import('../views/MasterDevices.vue')
  },
  {
    path: '/unregistered',
    name: 'Unregistered Devices',
    component: () => import('../views/UnregisteredDevices.vue')
  },
  {
    path: '/pushdata',
    name: 'Push Data',
    component: () => import('../views/PushData.vue')
  },
  {
    path: '/rtc-mismatch',
    name: 'RTC Mismatch',
    component: () => import('../views/RtcMismatch.vue')
  },
  {
    path: '/inventory',
    name: 'Inventory Management',
    component: () => import('../views/inventory/Dashboard.vue')
  },
  { 
    path: '/inventory/led-detail/:fp_no',
    name: 'Inventory details',
    component: () => import('../views/inventory/LedDetails.vue')
  },
  { 
    path: '/inventory/led-report',
    name: 'Inventory Reports',
    component: () => import('../views/inventory/LedReport.vue')
  },
  { 
    path: '/inventory/vendor',
    name: 'Inventory vendor Reports',
    component: () => import('../views/inventory/Vendor.vue')
  },
  { 
    path: '/inventory/lights',
    name: 'Inventory Lights Reports',
    component: () => import('../views/inventory/Lights.vue')
  },
   { 
    path: '/inventory/stock-history/:supervisorId',
    name: 'Stock History',
    component: () => import('../views/inventory/stockHistory.vue')
  },
  { 
    path: '/inventory/stock-used-history/:supervisorId',
    name: 'Stock History',
    component: () => import('../views/inventory/stockUsedHistory.vue')
  },
  { 
    path: '/inventory/led-driver-stock',
    name: 'led Driver Stock',
    component: () => import('../views/inventory/driverStock.vue')
  },
  { 
    path: '/inventory/led-driver-history/:supervisorId',
    name: 'Led Driver History',
    component: () => import('../views/inventory/driverHistory.vue')
  },
  /*{
    path: '/ulbmap',
    name: 'ULB Map',
    component: () => import('../views/UlbsMap.vue')
  },*/
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
